'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var LeftNavigationContext = require('./LeftNavigationContext.js');
var makeStyles = require('../../Styles/makeStyles.js');
var ListSubheader = require('../../DataDisplay/List/ListSubheader.js');
var Typography = require('../../DataDisplay/Typography/Typography.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var useStyles = makeStyles["default"](function (theme) {
  return {
    gutters: {
      paddingLeft: theme.spacing(3)
    },
    wrapper: {
      alignItems: 'flex-start',
      marginLeft: theme.spacing(3),
      marginTop: 24
    }
  };
});

var LeftNavigationSubHeader = function LeftNavigationSubHeader(_ref) {
  var label = _ref.label,
      rest = objectWithoutProperties(_ref, ["label"]);

  var _useLeftNavigationCon = LeftNavigationContext.useLeftNavigationContext(),
      isUsingList = _useLeftNavigationCon.isUsingList;

  var _useStyles = useStyles(),
      gutters = _useStyles.gutters,
      wrapper = _useStyles.wrapper;

  return isUsingList ? React__default["default"].createElement(ListSubheader, _objectSpread({
    disableSticky: true,
    classes: {
      gutters: gutters
    }
  }, rest), React__default["default"].createElement(Typography, {
    variant: "eyebrow"
  }, label)) : React__default["default"].createElement(Typography, {
    variant: "eyebrow",
    align: "left",
    component: "span",
    className: wrapper
  }, label);
};

module.exports = LeftNavigationSubHeader;
